enum TScenario {
  employeesHabits = "employees_habits",
  simplifiedLca = "simplified_lca",
  events = "events",
  travels = "travels",
  free = "free",
}

type TSimulation = {
  id: number;
  name: string;
  score: {
    id: number;
  };
  period_start: string;
  period_end: string;
  carbon_tons: number;
  employees: number;
  details_url: string;
  scenario?: TScenario;
};

type TCategoryName =
  | "business_trip"
  | "furniture"
  | "marketing"
  | "office"
  | "operations"
  | "other"
  | "saas_telecommunication"
  | "support"
  | "transport"
  | "usage";

type TSubCategoryName = string;

type TSubCategoryStatus = Record<TSubCategoryName, boolean>;

export type {
  TCategoryName,
  TSimulation,
  TSubCategoryName,
  TSubCategoryStatus,
};
export { TScenario };
